import { useUIContext } from 'lib/context/UIContext/UIContext';

import Button from 'components/shared/Button/Button';
import Checkbox from 'components/shared/Checkbox/Checkbox';

const Footer = ({
  isFooter,
  footer,
  showKeepEditingButton,
  showDontShowThisMessageAgain,
  dontShowAgain,
  setDontShowAgain,
  secondaryBtn,
  secondaryBtnTxt,
  handleClose,
  primaryBtn,
  primaryBtnTxt,
  variant,
  loading,
  disabled,
  handleContinue
}) => {
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  if (!isFooter) return null;

  if (typeof footer === 'object') return footer;

  return (
    <div className="flex flex-wrap-reverse justify-end gap-3 px-4 py-3">
      {showKeepEditingButton && (
        <Button
          size="small"
          className="text-xs text-neutral-700"
          variant="link"
          color="neutral"
          icon="edit-2-mono"
          iconColor="neutral"
          text="Keep editing"
          onClick={handleClose}
        />
      )}
      {showDontShowThisMessageAgain && !isMobile && (
        <Checkbox
          label="Don't show this message again"
          innerLabelClassName="gap-[6px]"
          labelTextColor="text-xs font-500 text-neutral-700"
          size={16}
          isChecked={dontShowAgain}
          onChange={() => setDontShowAgain(!dontShowAgain)}
        />
      )}
      {typeof secondaryBtn === 'object'
        ? secondaryBtn
        : !showKeepEditingButton &&
          !typeof secondaryBtn !== 'object' && (
            <Button
              data-qa="close-confirm-modal-btn"
              color="neutral"
              style="outlined"
              size="small"
              text={secondaryBtnTxt}
              onClick={handleClose}
            />
          )}
      {typeof primaryBtn === 'object' ? (
        primaryBtn
      ) : (
        <Button
          data-qa="proceed-confirm-modal-btn"
          size="small"
          color={variant}
          text={primaryBtnTxt}
          isLoading={loading}
          isDisabled={disabled}
          onClick={handleContinue}
        />
      )}
    </div>
  );
};

export default Footer;
